export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/absences', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/absence', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/absence/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/absence/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/absence/' + data.id, { params: data.filters || {} })
  }
})
